import React from 'react';
import { ReactSVG } from 'react-svg';

import './style.sass';

import arrowIcon from 'assets/img/icons/arrow-right.svg';
import { Link } from 'react-router-dom';

type Props = React.PropsWithChildren<{
    title?: string,
    subtitle?: string,
    isActiveHeader?: boolean,
    onClickBtn?: () => void,
    to?: string,
}>;

export const Card = ({
    title,
    subtitle,
    onClickBtn,
    isActiveHeader,
    children,
    to,
}: Props) => {
    return (
        <CardContainer className="card" to={to}>
            {isActiveHeader &&
                <div className="card__header">
                    <div className="card__title-wrapper">
                        {title && <h5 className="p1-medium dark-violet">{title}</h5>}
                        {subtitle && <span className="p2-regular grey-1">{subtitle}</span>}
                    </div>

                    {onClickBtn &&
                        <button className="card__button" onClick={onClickBtn}>
                            <ReactSVG src={arrowIcon} />
                        </button>
                    }
                </div>
            }

            <div className="card__body">
                {React.Children.map(children, (property, propertyIndex) => {
                    if (property) {
                        return (
                            <div
                                className="card__property"
                                key={`card_prop_${propertyIndex}`}
                            >
                                {property}
                            </div>
                        );
                    }
                })}
            </div>
        </CardContainer>
    );
};

type ContainerProps = React.PropsWithChildren & {
    to: string,
    className: string,
};

const CardContainer = ({ to, children, className }: ContainerProps) => {
    return to
        ? <Link to={to} className={className}>{children}</Link>
        : <div className={className}>{children}</div>;
};
